import React from "react";
import "./Language_Test.css";
import Blue_btn from "../../../../common_components/common_btn/blue_btn/Blue_btn";
import { faCertificate } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
function Language_Test() {
  const navigate = useNavigate();
  return (
    <>
      <section className="language_test_section ">
        <div className="top_cards_section_colder">
          <div className="row">
            <div className="col-lg-6">
              <div className="heading_text_holder">
                <h1>Language Test</h1>
                <h4>
                  Assess your French language level to qualify For
                  <span> International Internships</span>
                </h4>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="test_top_boxes">
                <div className="row">
                  <div className="col-md-4 col-sm-4">
                    <div className="top_box">
                      <div>
                        <h3>15-20 Min</h3>
                        <p>Duration</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4  col-sm-4">
                    <div className="top_box">
                      <div>
                        <h3>10 Q.</h3>
                        <p>Questions</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4  col-sm-4">
                    <div className="top_box">
                      <div>
                        <h3>A1 - C1</h3>
                        <p>Levels</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* About Test Box */}
        <div className="about_test_card card_box">
          <div className="heading_text_holder">
            <h1>About the Test</h1>
            <h4>
              This test evaluates your French level according to the Common
              European Framework of Reference
            </h4>
          </div>

          <h3 className="instructions_title">Instructions:</h3>

          <div className="instructions_box card_box">
            <div className="instruction_item">
              <span className="icon">
                <FontAwesomeIcon icon={faCertificate} />
              </span>
              <p>Answer all questions to the best of your ability</p>
            </div>

            <div className="instruction_item">
              <span className="icon">
                <FontAwesomeIcon icon={faCertificate} />
              </span>
              <p>Questions progressively increase in difficulty</p>
            </div>

            <div className="instruction_item">
              <span className="icon">
                <FontAwesomeIcon icon={faCertificate} />
              </span>
              <p>
                A minimum B1 level is recommended for international internships
              </p>
            </div>

            <div className="instruction_item">
              <span className="icon">
                <FontAwesomeIcon icon={faCertificate} />
              </span>
              <p>You will receive your result immediately after the test</p>
            </div>

            <div className="btn_holder">
              <Blue_btn
                btn_text={"Start Test"}
                onClick={() => navigate("/portal/student/language-test-step-form")}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Language_Test;
